export const TASK_TYPE = {
  INDIVIDUAL: 'individual',
  GROUP: 'group',
  CONTENT: 'content'
};

export const STUDENT_TASK_STATUS = {
  TO_REVIEW: 'toReview',
  REVIEWED: 'reviewed',
  PENDING: 'pending'
};

// NOTE: The backend does not expose an explicit task type field.
// Type is inferred from task shape:
//   - bookId present → CONTENT
//   - first studentAttempt has taskGroup → GROUP (fragile: only reliable after at least one student has an attempt)
//   - otherwise → INDIVIDUAL
// If the backend ever adds a type field, replace this function with a direct read.
export function getTaskType(task) {
  if (task.bookId) return TASK_TYPE.CONTENT;
  if (task.studentAttempts) {
    const attempts = Object.values(task.studentAttempts);
    if (attempts.length > 0 && attempts[0] && attempts[0].taskGroup) return TASK_TYPE.GROUP;
  }
  return TASK_TYPE.INDIVIDUAL;
}

export function getStudentAttemptData(task, userId) {
  if (!task || !task.studentAttempts || !task.studentAttempts[userId]) {
    return { responses: [], evaluation: null, canStudentRepeat: false, taskGroup: null };
  }
  return task.studentAttempts[userId];
}
